import { detectMobileWebOsFromUserAgent } from '../../onboarding/helpers/detectMobileWebOsFromUserAgent.helper';

type AppleSignInUiPlatform = 'ios' | 'android' | 'web' | (string & {});

/**
 * Whether the Continue with Apple button should render for the given platform/UA.
 * Hidden on Android (native app and mobile web); shown on iOS and desktop web.
 */
export function isAppleSignInUiSupportedFromContext(
  platform: AppleSignInUiPlatform,
  userAgent: string | null | undefined,
): boolean {
  if (platform === 'android') return false;
  if (platform === 'ios') return true;
  if (platform === 'web') {
    return detectMobileWebOsFromUserAgent(userAgent) !== 'android';
  }
  return false;
}
